
import {
	Component,
	Vue
} from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import {
	productNetIncomeList
} from '@/api/order';
import {
	providerSelectItem
} from '@/api/supplier';
import {
	getSearchDate,
	nextDay
} from "@/utils/index"


@Component({
	name: 'order-product',
	components: {
		PageFooter,
		PickerDate
	}
})
export default class OrderProduct extends Vue {
	private defThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png'
	private productNameKey = ''
	private supplierNameKey = '';
	private supplierList: any = []
	private IDKey = ''
	private list: any[] = [];
	private pageNo = 1;
	private pageSize = 10;
	private total = 0;
	private filterTime: any = getSearchDate(1, true)
	private tableloading = false

	private mounted() {
		this.getList()
		this.getSupplierList()
	}

	// 获取供应商列表
	private async getSupplierList() {
		try {
			const res: any = await providerSelectItem({});
			this.supplierList = res.Result.map(v => {
				return {
					value: v.Id,
					label: v.ProviderName
				}
			})
		} catch (e) {
			console.log('supplierList ===>', e);
		}
	}

	private handleExport() {
		let url = location.origin + '/pc/order/productNetIncomeList' +
			'?Keywords=' + (this.productNameKey || '') +
			'&ProviderId=' + (this.supplierNameKey || '') + 
			'&StartTime=' + (this.filterTime[0] || '') + 
			'&EndTime=' + (this.filterTime[1] || '');

		window.open(url)
	}

	private changePage(e) {
		this.pageNo = e
		this.getList()
	}

	private async getList() {
		let param: any = {
			Skip: (this.pageNo - 1) * this.pageSize,
			Take: this.pageSize,
			Keywords: this.productNameKey,
			ProviderId: this.supplierNameKey,
			StartTime: this.filterTime[0],
			EndTime: this.filterTime[1]
		}

		try {
			this.tableloading = true
			const res: any = await productNetIncomeList(param);
			let obj = res.Result.TotalStatistic;
			obj.ProductId = '总计';
			obj.ProductName = '';
			obj.ProviderName = '';

			let list = res.Result.Results;
			list.unshift(obj);

			this.list = res.Result.Results;
			this.total = res.Result.Total;
		} catch (e) {
			console.log(e)
		} finally {
			this.tableloading = false
		}
	}

	private doSearch() {
		this.pageNo = 1;
		this.getList();
	}

	private clearSearch() {
		this.pageNo = 1;
		this.productNameKey = ''
		this.supplierNameKey = ''
		this.filterTime = getSearchDate(1, true);
		this.getList()
	}

	private toDetail(id: number) {
		this.$router.push({
			name: 'Order_Product_detail',
			query: {
				id: id + '',
				filterTime: this.filterTime
			}
		})
	}
}
